import { Component } from "@angular/core"
import { ViewController, NavParams, AlertController, NavController } from "ionic-angular"

import { ProfilePage } from "../profile"

@Component({
  selector: "user-pick-list-page",
  templateUrl: "pick-list.html",
})
export class UserPickListPage {

  users = []
  options: any = {}

  constructor(
    private navParams: NavParams,
    private alertCtrl: AlertController,
    private viewCtrl: ViewController,
    private navCtrl: NavController
  ) {

    this.users = this.navParams.get("users")
    this.options = this.navParams.get("options")
  }

  pickOneOrMultiple() {

    return (this.options.pickOne || this.options.pickMultiple)
  }

  onCancel() {

    this.viewCtrl.dismiss()
  }

  onConfirm() {

    let selectedUsers = []

    this.users.forEach((user) => {

      if (user.selected)
        selectedUsers.push(user)
    })

    if (selectedUsers.length > 0) {

      this.viewCtrl.dismiss(selectedUsers)

    } else {

      this.alertCtrl.create({
        message: "Nenhum profissional selecionado",
        buttons: ["Ok"]
      }).present()
    }
  }

  onSelectAll() {

    this.users.forEach((user) => user.selected = true)
  }

  onTapUser(user) {

    if (!this.pickOneOrMultiple())
      return

    user.selected = !user.selected

    if (this.options.pickOne) {

      this.users.forEach((el) => {

        if (el._id != user._id)
          el.selected = false
      })
    }
  }

  onPressUser(user) {

    this.navCtrl.push(ProfilePage, { user })
  }
}



// WEBPACK FOOTER //
// ./src/pages/users/pick-list.ts